/* eslint-disable no-restricted-imports */
import { DpIARecommendationResponse } from 'integration/generated/transactions/data-contracts';
import { ProductType } from '@/data/types/Product';
import valueIsNullOrUndef from 'integration/utils/typeAssertions/valueIsNullOrUndef';

export const catalogEntryOrderIaRecommendation = (
	order: string,
	products: ProductType[],
	data: DpIARecommendationResponse
) => {
	if (order === 'similarity') {
		const similarityMap = new Map(
			data.data?.recommendations.map((item) => [item.id, item.similarity]) ?? []
		);
		return [...products].sort(
			(a, b) => (similarityMap.get(b.partNumber) ?? 0) - (similarityMap.get(a.partNumber) ?? 0)
		);
	}

	if (order === 'ascending-price') {
		return [...products].sort((a, b) => {
			const priceA = a.productPrice.offer ?? a.productPrice.list ?? 0;
			const priceB = b.productPrice.offer ?? b.productPrice.list ?? 0;
			return priceA - priceB;
		});
	}

	if (order === 'descending-price') {
		return [...products].sort((a, b) => {
			const priceA = a.productPrice.offer ?? a.productPrice.list ?? 0;
			const priceB = b.productPrice.offer ?? b.productPrice.list ?? 0;
			return priceB - priceA;
		});
	}

	if (order === 'ascending-offer' || order === 'descending-offer') {
		const hasDiscount = (p: ProductType) => {
			const { offer, list } = p.productPrice;
			return !valueIsNullOrUndef(offer) && !valueIsNullOrUndef(list) && offer < list;
		};
		const byPriceAsc = (a: ProductType, b: ProductType) => {
			const priceA = a.productPrice.offer ?? a.productPrice.list ?? 0;
			const priceB = b.productPrice.offer ?? b.productPrice.list ?? 0;
			return priceA - priceB;
		};
		const withOffer = products.filter(hasDiscount).sort(byPriceAsc);
		const withoutOffer = products.filter((p) => !hasDiscount(p)).sort(byPriceAsc);
		return order === 'ascending-offer'
			? [...withOffer, ...withoutOffer]
			: [...withoutOffer, ...withOffer];
	}

	return products;
};
